import React, { useEffect,useState } from 'react'
import { TextField, Grid, Box, Button } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsOne_2Schema } from '../../Utils/Validations'
import { usePlacesWidget } from "react-google-autocomplete";
import PhoneInput from 'react-phone-input-2'

// Custom styles for phone input placeholder
const phoneInputStyles = `
  .react-tel-input .form-control::placeholder {
    color: #999999 !important;
    opacity: 1 !important;
  }
`;
const DriveWithUsOne_2 = ({ handleBack, handleComplete, driveUsData, setDriveUsData }) => {
  
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(DriveUsOne_2Schema)
  })
  useEffect(() => {
    setValue("phone", driveUsData.phone || "")
    setValue("address", driveUsData.address || "")
    setValue("apt", driveUsData.apt || "")
    setValue("city", driveUsData.city || "")
   
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setDriveUsData((prev) => ({ ...prev, phone: `+${data.phone}`,address:data.address,apt: data.apt,city:data.city}))
    handleComplete()
  }




  const { ref } = usePlacesWidget({
    apiKey: 'AIzaSyBy2l4KGGTm4cTqoSl6h8UAOAob87sHBsA',
    onPlaceSelected: (place) => {
        const addresses = place?.formatted_address;
        console.log("Old Data....",addresses);
        setValue("address",addresses)
        setDriveUsData((prev) => ({ ...prev, address:addresses}))
        
       
    },
    options: {
        types: ["(regions)"]
    }
    
 } 

 
 )
  return (
    <div>
      <style>{phoneInputStyles}</style>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
        <Controller
            control={control}
            name="phone"
            rules={{ required: true }}
            render={({ field:{onChange,value} }) => (
              <>
                <label>Phone Number</label>
                <PhoneInput 
                  disableCountryCode 
                  onlyCountries={["us"]} 
                  country={"us"} 
                  placeholder='Enter your 10 digit phone number' 
                  value={value} 
                  onChange={(p)=>onChange(p)}
                  containerStyle={{
                    width: '100%'
                  }}
                />
              { errors.phone? <p className='error-message' > {errors?.phone?.message}</p>:null}
              </>
            )}
          />
         
{/* <input ref={ref}   placeholder='Your Address'   /> */}

        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, marginTop: { sm: 0, xs: 2 } }} >
        <Controller
            control={control}
            name="address"
            rules={{ required: true }}
            render={({ field:{onChange,value}}) => (
              <>
                <label>Full Address</label>
                <TextField   onChange={onChange} value={value}  fullWidth placeholder='Full Address'  error={errors?.address} helperText={errors?.address?.message} />
              </>
            )}
          />
       

        
        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 },mt:3 }} >
        <Controller
            control={control}
            name="apt"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Apt, Suite, Unit, Bulding, Floor, etc</label>
                <TextField  fullWidth placeholder='Apt,Suite,unit,Bulding,Floor,etc' {...field} error={errors?.apt} helperText={errors?.apt?.message} />
              </>
            )}
          />
         
{/* <input ref={ref}   placeholder='Your Address'   /> */}

        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt:3 }} >
        <Controller
            control={control}
            name="city"
            rules={{ required: true }}
            render={({ field:{onChange,value}}) => (
              <>
                <label>City</label>
                <TextField   onChange={onChange} value={value}  fullWidth placeholder='City'  error={errors?.city} helperText={errors?.city?.message} />
              </>
            )}
          />
       
        
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsOne_2